/* eslint-disable */
import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'

export default Image.extend({
    name: 'custom-image',

    addAttributes() {
        return {
            ...Image.config.addAttributes(),
            width: {
                default: "auto",
                // rendered: false
            }

        }
    },

    addCommands() {
        return {
            setImage: (options) => ({ tr, commands }) => {
                // console.log(options, tr, commands);

                if(tr.selection?.node?.type?.name == 'custom-image') {
                    return commands.updateAttributes('custom-image', options)
                }
                else {
                    return commands.insertContent({
                        type: this.name,
                        attrs: options
                    })
                }
            },
        }
    },

    renderHTML({ node, HTMLAttributes }) {
        //HTMLAttributes.class = ' custom-image-' + node.attrs.size

        if (!node.attrs.width)
            node.attrs.width = "auto"

        HTMLAttributes.width = node.attrs.width
        // console.log(this.options.HTMLAttributes, HTMLAttributes);

        return [
            'img',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
        ]
    }
})
